// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__k-rSE","actions":"styles_actions__HHTBE","actions_btn":"styles_actions_btn__RGBXj"};